<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="false" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"></ReturnNavBar>
            <div class="mobile_head_operate" >
                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                    <ul class="head_operate_popover_list">
                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                            <i :class="item.icon"></i> <span v-text="item.text"></span>
                        </li>
                    </ul>
                    <template #reference>
                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                    </template>
                </van-popover>
            </div>
        </div>
        <div class="warehouse_add_container mobile_container">
            <div class="warehouse_add_wrap">
                <div class="related_num" v-if="related_info && related_info.related_num">业务编号：<span v-text="related_info.related_num" class="link-label"  @click="handleClickRelatedDetail"></span></div>

                <div class="product_list">
                    <ul>
                        <li v-for="item in formData.productData" :class="item.last ? 'last_li' : ''">
                            <div class="goods_info" v-if="pending_info && pending_info.biz_type == 'order' && item.first" >
                                <div v-if="item.goods_info">
                                    <div v-if="item.goods_info.goods_type == 'bundle'">
                                        <div class=" goods_name">
                                            <h5>
                                                {{item.goods_info.goods_name}}
                                                <span class="danger_text" v-text="item.goods_info.type == 1 ? '(销售)' : '(租借)'"></span>
                                            </h5>
                                            <span class="link-label" @click="item.expand = !item.expand">展开配置 <i class="iconfont icon-xiajiantou"></i></span>
                                        </div>
                                        <div class="goods_child_name" v-if="item.expand">
                                            <p  v-for="child in item.goods_info._child" v-text="child.goods_name"></p>
                                        </div>

                                    </div>
                                    <div v-else class="goods_name">
                                        <h5>{{item.goods_info.goods_name}} <span  class="danger_text"  v-text="item.goods_info.type == 1 ? '(销售)' : '(租借)'"></span></h5>
                                    </div>
                                </div>

                            </div>

                            <div class="product_field product_border flex_js_wrap">
                                <div class="product_name_wrap">
                                    <div class="product_name ellipsis" v-text="item.name"></div>
                                    <span class="audit_num ellipsis" v-text="item.audit_num + item.unit"></span>
                                </div>
                            </div>
                            <div class="product_field product_border">
                                <van-field @click="handleClickSelectStock(item)" clickable is-link label="" :value="item.stock_name"  name="stock_id" :disabled="pending_info && pending_info.stock_type == 'transfer_in'" placeholder="请选择入库仓库"  readonly></van-field>
                            </div>

                            <div class="product_field product_border" v-if="pending_info && pending_info.biz_type == 'purchase'">
                                <van-field v-model="item.cost_price" type="number" label="" readonly >
                                    <template #button>
                                        <span>(￥)</span>
                                    </template>
                                </van-field>
                            </div>

                            <div class="product_field ">
                                <div class="bt required">入库数量/产品编码</div>
                                <div class="select_number flex_js_wrap">
                                    <van-field v-model="item.no_code_num" @change="handleChangeNum(item)" :disabled="(pending_info && pending_info.biz_type == 'order' && !item.audit_no_code_num)  ? true : false" type="" label="" placeholder="请输入数量"></van-field>
                                    <div class="select_code_box flex_js_wrap">
                                       <span>
                                            <span class="line"></span>
                                            <span class="select_btn" @click="handleClickSelectCode(item)" v-text="(pending_info && (pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel')) ? '选择编码' :'输入编码'"></span>
                                       </span>
                                        <span class="total_num">共{{item.total_num}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                </div>

                <div class="field_item">
                    <div class="field_name">附件</div>
                    <div class="field_content">
                        <div class="file_list" v-if="formData.file_list && formData.file_list.length>0">
                            <ul>
                                <li v-for="(file, file_idx) in formData.file_list" :key="file_idx">
                                    <p class="ellipsis" v-text="file.file_name"></p>
                                    <div>
                                        <span @click="handleClickPreview(file)"><i class="iconfont icon-yanjing"></i></span>
                                        <span @click="formData.file_list.splice(file_idx,1)"><i class="iconfont icon-shanchu1"></i></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="file_note" v-else>支持.rar .zip .doc .docx .pdf .jpg...</div>
                        <div class="file_upload">
                            <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            <i class="iconfont icon-upload"></i>上传附件
                        </div>

                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">备注信息</div>
                    <div class="field_content">
                        <van-field
                                v-model="formData.note"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入备注信息"
                        />
                    </div>
                </div>

            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
        <SelectStock  :selectStockPopupShow.sync="selectStockPopupShow" v-if="selectStockPopupShow" :selectedStockId="(productInfo && productInfo.stock_id) ? productInfo.stock_id : 0" @success="selectStockSuccess"/>
        <CodeIdentification :codeIdentificationPopupShow.sync="codeIdentificationPopupShow" v-if="codeIdentificationPopupShow" :sourceType="'in'" :productInfo="productInfo" :relatedType="pending_info.related_type" :related_info="related_info"  :selectedCodeData="selectedCodeData" :maxCodeIdentification="maxCodeIdentification" @success="selectCodeSuccess" />
        <SelectCode  :selectCodePopupShow.sync="selectCodePopupShow" v-if="selectCodePopupShow"  :selectedCodeData="selectedCodeData" :productInfo="productInfo"  :relatedId="related_info.related_id" :stockType="pending_info.stock_type" @success="selectCodeOneSuccess" />

    </div>
</template>

<script>
import {Dialog, ImagePreview} from "vant";
import { pendingInDetail,codeInGetProduct,pendingIn} from "@/api";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize,removeTag} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import SelectStock from "../component/select_stock"
import CodeIdentification from "../component/code_identification"
import SelectCode from "../component/select_code"
import {EventBus} from '@/utils/eventBus';
export default {
    name: "InWarehouseAudit",
    components: {ReturnNavBar,SelectStock,SelectCode,CodeIdentification},
    data() {
        return {
            loading:false,
            formData:{
                productData:[],
                file_list:[],
                note:''
            },
            btnDisabled:false,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:"codeIdentification", text: "粘贴编码识别", icon: "iconfont icon-chuku" },
                {value:"scan", text: "扫码入库", icon: "iconfont icon-saoyisao" },
                {value:"batch_stock", text: "批量选择仓库", icon: "iconfont icon-piliangcaozuo" },
            ],

            selectStockPopupShow:false,
            productInfo:null,
            codeIdentificationPopupShow:false,
            selectedCodeData:[],//已选编码



            related_info:null,
            pending_info:null,
            default_bring:['transfer_in','transfer_in_cancel'],
            selectCodePopupShow:false,
            maxCodeIdentification:null, //最大识别编码数量
        };
    },
    created() {
        this.stock_pending_id = this.$route.query.stock_pending_id
        if(this.stock_pending_id){
            this.getPendingInDetail()
        }
    },
    methods: {

        // 获取详情
        getPendingInDetail(){
            pendingInDetail({ stock_pending_id:this.stock_pending_id }).then(res => {
                if (res.code === 200) {
                    let {related_info,product_list,pending_info,goods_list} = res.data
                    this.related_info = related_info
                    this.related_info.stock_pending_id = this.stock_pending_id
                    goods_list.forEach(item => {
                        item.goodsChildIds = []
                        if(item._child){
                            item.goodsChildIds = item._child.map(child => child.order_goods_id)
                        }
                        item.goodsChildIds.push(item.order_goods_id)
                    })
                    let productData  = product_list.map(item => {
                        let goods_info = null
                        if(pending_info.biz_type == 'order'){
                            goods_info = goods_list.find(find => find.goodsChildIds.indexOf(item.related_detail_id) > -1)
                            let goods_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_id
                            let goods_sku_id = item.related_detail_id == goods_info.order_goods_id ? goods_info.goods_sku_id : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).goods_sku_id
                            let audit_code_num = item.related_detail_id == goods_info.order_goods_id ? goods_info.code_num : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).code_num
                            let audit_no_code_num = item.related_detail_id == goods_info.order_goods_id ? goods_info.no_code_num : goods_info._child.find(child => child.order_goods_id == item.related_detail_id).no_code_num
                            return {
                                audit_code_num, //待入库的编码数量
                                audit_no_code_num,//待入库的无编码数量
                                goods_id,
                                goods_sku_id,
                                goods_info:goods_info,
                                related_detail_id:item.related_detail_id,
                                loss_num:0,
                                loss_note:'',
                                name:item.product_name,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                is_unit:item.unit ? true :false,
                                cost_price:item.cost_price,
                                stock_id:item.stock_id ? item.stock_id : '',
                                audit_num:item.num,//待入库数量
                                no_code_num:0, //输入的无编码数量
                                code_num: 0, //选择的有编码数量
                                code_list: [], //选择的编码
                                total_num: 0, //选择的总数量
                                not_found_code:[], // 不存在的编码
                                unmatched_code:[],//已存在未绑定的编码
                                expand:false
                            }
                        }else{
                            return {
                                loss_num:0,
                                loss_note:'',
                                name:item.product_name,
                                related_detail_id:item.related_detail_id ? item.related_detail_id : 0,
                                stock_pending_product_id:item.stock_pending_product_id,
                                related_type:item.related_type,
                                related_id:item.related_id,
                                sku_id:item.sku_id,
                                sku_key:item.sku_key,
                                unit:item.unit,
                                is_unit:item.unit ? true :false,
                                cost_price:item.cost_price,
                                stock_id:item.stock_id ? item.stock_id : '',
                                stock_name:item.stock_name ? item.stock_name : '',
                                audit_num:item.num,//待入库数量
                                no_code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.no_code_num) ? item.no_code_num : 0, //输入的无编码数量
                                code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.code_num) ? item.code_num : 0, //选择的有编码数量
                                code_list:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.code_list) ? item.code_list : [], //选择的编码
                                all_code_list:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel' ) && item.code_list) ? item.code_list : [], //转移入库时可选择的编码
                                total_num:(pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') ? Number(item.no_code_num) + Number(item.code_num) : 0, //选择的总数量

                                audit_code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.no_code_num) ? item.no_code_num : 0,  //待入库的无编码数量
                                audit_no_code_num:((pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel') && item.code_num) ? item.code_num : 0, //待入库的编码数量
                                not_found_code:[], // 不存在的编码
                                unmatched_code:[],//已存在未绑定的编码
                            }
                        }

                    })

                    if(pending_info.biz_type == 'order') {
                        productData.sort((a, b) => {
                            return a.goods_id - b.goods_id; // 升序排序
                        });
                    }
                    // 这组数据相同goods_id的会挨着，需要用  js 把相同goods_id的第一个加一个first 字段 = true 最后一个加last = true   只有一个的话都加
                    let currentGoodsId = null;
                    let firstIndex = null;
                    for (let i = 0; i < productData.length; i++) {
                        const item = productData[i];
                        if (item.goods_id!== currentGoodsId) {
                            if (firstIndex!== null) {
                                productData[firstIndex].first = true;
                                productData[i - 1].last = true;
                            }
                            currentGoodsId = item.goods_id;
                            firstIndex = i;
                        }
                        if (i === productData.length - 1) {
                            productData[firstIndex].first = true;
                            productData[i].last = true;
                        }
                    }
                    console.log(productData);

                    this.formData.productData = productData
                    this.pending_info = pending_info
                    // 采购或者转移的时候不能编码识别
                    if(pending_info.related_type == 'purchase' || pending_info.stock_type == 'transfer_in' || pending_info.stock_type == 'transfer_in_cancel'){
                        this.headOperateActionsList = [
                            {value:"batch_stock", text: "批量选择仓库", icon: "iconfont icon-piliangcaozuo" },
                        ]
                    }

                }
            })
        },
        // 输入无编码数量
        handleChangeNum(item){
            const num = item.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num)) {
                this.$set(item,'no_code_num',0)
            } else {
                if(this.pending_info.biz_type == 'order' || this.pending_info.stock_type == 'transfer_in' || this.pending_info.stock_type == 'transfer_in_cancel'){
                    // 如果是订单 / 转移 的时候，如果输入的无编码数量大于待办的无编码数量，则等于待办的无编码数量
                    if(item.no_code_num > item.audit_no_code_num){
                        this.$set(item,'no_code_num',item.audit_no_code_num)
                    }
                }
                // 如果输入的数量大于待入库总数量则等于总数量
                let total_num = Number(item.no_code_num) + Number(item.code_num) + Number(item.loss_num)
                if(total_num > item.audit_num){
                    this.$set(item,'no_code_num',Number(item.audit_num) - Number(item.code_num) - Number(item.loss_num))
                }

            }
            this.$nextTick(()=>{
                this.$set(item,'total_num',Number(item.no_code_num) + Number(item.code_num))
            })
        },
        // 选择产品编码
        handleClickSelectCode(item){
            this.productInfo = item
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            // 如果是转移入库的话
            if(this.pending_info.stock_type == 'transfer_in' ||this.pending_info.stock_type == 'transfer_in_cancel'){
                if(item.all_code_list.length == 0){
                    return  this.$toast('该产品入库数量/产品编码合计不可超过待入库数量')
                }
                this.selectCodePopupShow = true
            }else{
                let maxCodeIdentification = item.audit_num - item.total_num
                this.maxCodeIdentification = maxCodeIdentification
                this.codeIdentificationPopupShow = true
            }
        },
        // 转移选择编码后回调
        selectCodeOneSuccess(data){
            this.maxCodeIdentification = null
            // 如果是转移入库  转移取消入库 的话
            if(this.pending_info.stock_type == 'transfer_in' || this.pending_info.stock_type == 'transfer_in_cancel') {
                this.$set(this.productInfo, 'code_list', data.map(item => item.code))
                this.$set(this.productInfo, 'code_num', this.productInfo.code_list.length)
                this.$set(this.productInfo, 'total_num', Number(this.productInfo.no_code_num) + Number(this.productInfo.code_num))
            }
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            this.maxCodeIdentification = null
            if(this.productInfo && this.productInfo.name){
                let {code_list, selected_code_list, not_found_code, unmatched_code} = data
                this.$set(this.productInfo,'code_list',selected_code_list.concat(code_list)) //已选的+ 新增的
                this.$set(this.productInfo,'not_found_code',this.productInfo.not_found_code.concat(not_found_code)) //不存在的
                this.$set(this.productInfo,'unmatched_code',this.productInfo.unmatched_code.concat(unmatched_code)) //存在没绑定
                this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
                this.$set(this.productInfo,'total_num',Number(this.productInfo.no_code_num) + Number(this.productInfo.code_num))
            }else{
                this.loading = true
                let code_list = []
                this.formData.productData.forEach((item, key) => {
                    let code = item.code_list.map(map => map.code)
                    code_list = [...code_list, ...code]
                })
                let codeList = data.code_list.filter(item => !code_list.includes(item));
                if(codeList.length != data.code_list.length){
                    this.$toast('检查到有重复的编码已经为您去重')
                }
                if(codeList.length == 0){this.loading = false;  return  false }
                codeInGetProduct({code_list:codeList,related_type:this.related_info.related_type,related_id:this.related_info.related_id}).then(res => {
                    if (res.code === 200) {
                        let {data} = res
                        data.forEach((item,key)=>{
                            this.mergeProductFunction(item)
                        })
                    }
                    this.loading = false
                })


            }
        },
        mergeProductFunction(row){
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key && item.related_detail_id == row.related_detail_id){
                        this.$set(item,'code_list',item.code_list.concat(row.code_list))
                        this.$set(item,'code_num',item.code_list.length)
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                    }
                })
            }
        },
        // 头部+号操作
        handleClickHeadOperate(item){
            this.headOperatePopoverShow = false
            if(item.value == 'codeIdentification'){
                this.productInfo = null
                this.selectedCodeData = []
                this.formData.productData.forEach(item =>{
                    this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
                })
                this.codeIdentificationPopupShow = true
            }else if(item.value == 'batch_stock'){
                this.productInfo = null
                this.selectStockPopupShow = true
            }
        },
        // 选择仓库
        handleClickSelectStock(item){
            if(this.pending_info && this.pending_info.stock_type == 'transfer_in'){
                return false
            }
            this.productInfo = item
            this.selectStockPopupShow = true
        },
        // 选择仓库后回调
        selectStockSuccess(data){
            if(this.productInfo){
                this.$set(this.productInfo,'stock_id',data.id)
                this.$set(this.productInfo,'stock_name',data.name)
            }else{
                this.formData.productData.forEach(item =>{
                    this.$set(item,'stock_id',data.id)
                    this.$set(item,'stock_name',data.name)
                })
            }
            this.productInfo = null
        },
        // 关联查看详情
        handleClickRelatedDetail(){
            if(this.pending_info.related_type == 'purchase'){
                this.$router.push({
                    name:'purchaseDetail',
                    query:{
                        purchase_id:this.related_info.related_id
                    }
                })
            }else if(this.pending_info.biz_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:this.related_info.related_id,
                        name:this.related_info.related_num,
                    },
                });
            }
        },
        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            console.log(files);
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickReturnRouter(){
            if (this.formData.note || this.formData.file_list.length > 0 || this.formData.productData.filter(item => (item.stock_id || item.total_num)).length>0 ){
                Dialog.confirm({
                    title: "取消",
                    message: "取消后，编辑内容不保留，是否取消！",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                })
                .then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                })
                .catch(() => { });
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm() {
            let flag = false
            let product_list = JSON.parse(JSON.stringify(this.formData.productData))
            let post_product_list = []
            product_list.forEach((item,index) => {
                if(this.pending_info.biz_type == 'order'){
                    delete item.cost_price
                }
                delete item.is_unit
                delete item.audit_num
                delete item.audit_code_num
                delete item.audit_no_code_num
                delete item.stock_name
                delete item.all_code_list

                if(!item.stock_id && item.total_num && !flag ){
                    this.$toast('请选择入库仓库')
                    flag = true
                }
                if((item.total_num && item.stock_id) || item.loss_num){
                    if((item.stock_id && !item.total_num) || (!item.stock_id && item.total_num) ){
                        item.stock_id = ''
                        item.total_num = 0
                    }
                    post_product_list.push(item)
                }
            })

            if(flag){return  false}
            if(post_product_list.length == 0){return this.$toast('请至少入库一个产品')}
            let postData = {
                product_list:post_product_list,
                files:this.formData.file_list,
                note:this.formData.note,
                stock_pending_id:this.stock_pending_id,

                stock_type:this.pending_info.stock_type,
                approval_id:this.pending_info.approval_id,
                approval_uid:this.pending_info.uid,
                // approval_type:this.pending_info.approval_type,
                // approval_set_id:this.pending_info.approval_set_id,
                related_type:this.related_info.related_type,
                related_id:this.related_info.related_id,
                related_num:this.related_info.related_num,
            }

            Dialog.confirm({
                title: "提交入库",
                message: "确定执行入库操作吗？ \r\n 提交后无法撤回，请谨慎操作。",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                this.btnDisabled = true
                pendingIn(postData).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            type: 'success',
                            message:'入库成功',
                            duration: 1500,
                            onClose: () => {
                                EventBus.$emit('inventoryInUpdated');
                                removeTag(this.$route)
                                this.$router.go(-1);
                                this.btnDisabled = false
                            }
                        })
                    }else{
                        this.btnDisabled = false
                    }
                })
            })
            .catch(() => { });
        },

    },
};
</script>

<style lang="scss" scoped>
.warehouse_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .warehouse_add_wrap{
        background: #fff;
        .related_num{
            padding: 12px 16px 4px;
            box-sizing: border-box;
            line-height: 22px;
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
        }
        .product_list{
            width: 100%;
            padding: 12px 16px;
            box-sizing: border-box;
            ul{
                li{
                    width: 100%;
                    margin-bottom: 10px;
                    border-radius: 6px;
                    background: rgba(247, 248, 250, 1);
                    &.last_li{
                        position: relative;
                        &:after{
                            content: '';
                            position: absolute;
                            left: -16px;
                            right: -16px;
                            bottom: -10px;
                            width: calc(100% + 32px);
                            height: 1px;
                            background: rgba(232, 232, 232, 1);
                        }
                    }
                    &:last-child{
                        margin-bottom: 0;
                        &:after{
                            display: none;
                        }
                    }
                    .goods_info{
                        width: 100%;
                        padding: 10px 0;
                        box-sizing: border-box;
                        background: #fff;
                        .goods_name{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            h5{
                                font-size: 16px;
                                color: rgba(51, 51, 51, 1);
                                line-height: 24px;
                                font-weight: bold;
                                max-width: calc(100% - 84px);
                                margin-right: 4px;
                            }
                            .danger_text{
                                color: rgb(228, 65, 68);
                            }
                            .link-label{
                                width: 80px;
                                font-size: 14px;
                            }
                        }
                        .goods_child_name{
                            width: 100%;
                            line-height: 18px;
                            font-size: 12px;
                            color: rgba(102, 102, 102, 1);
                            margin-top: 4px;
                        }
                    }

                    .product_field{
                        width: 100%;
                        padding: 0 12px;
                        .van-popover__wrapper{
                            flex: 1;
                            display: block;
                        }
                        &.product_border{
                            position: relative;
                            &:before{
                                position: absolute;
                                width: calc(100% - 24px);
                                height: 1px;
                                background: rgba(232, 232, 232, 1);
                                content: " ";
                                left: 12px;
                                bottom: 0;
                                z-index: 9;
                            }
                        }
                        .van-cell{
                            padding-left: 0;
                            padding-right: 0;
                            background: rgba(247, 248, 250, 1);
                        }
                        .field_button{
                            font-size: 14px;
                            padding-left: 8px;
                            color: rgba(41, 144, 255, 1);
                            line-height: 14px;
                            border-left: 1px solid rgba(232, 232, 232, 1);
                        }

                        .bt{
                            padding-top: 10px;
                            line-height: 22px;
                            font-size: 14px;
                            color: rgba(51, 51, 51, 1);
                            &.required{
                                position: relative;
                                padding-left: 6px;
                                &:before{
                                    position: absolute;
                                    left: 0;
                                    top: 10px;
                                    content: "*";
                                    color: rgba(228, 65, 68, 1);
                                }
                            }
                        }
                        .select_number{
                            width: 100%;
                            .van-cell{
                                width: 78px;
                            }
                            .select_code_box{
                                flex: 1;
                                line-height: 24px;
                                position: relative;
                                .select_btn{
                                    font-size: 14px;
                                    color: rgba(41, 144, 255, 1);
                                }
                                .total_num{
                                    border-radius: 4px;
                                    background: rgba(255, 255, 255, 1);
                                    min-width: 22px;
                                    padding: 0 4px;
                                    line-height: 22px;
                                    font-size: 14px;
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }

                        .product_name_wrap{
                            width: 100%;
                            padding: 10px 0;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            .product_name{
                                font-weight: bold;
                                font-size: 14px;
                                color: rgba(51, 51, 51, 1);
                                line-height: 22px;
                                max-width: calc(100% - 80px);
                            }
                            .audit_num{
                                height: 22px;
                                opacity: 1;
                                border-radius: 4px;
                                background: rgba(255, 255, 255, 1);
                                padding: 0 4px;
                                box-sizing: border-box;
                                font-weight: bold;
                                font-size: 14px;
                                color: rgba(51, 51, 51, 1);
                                line-height: 22px;
                            }
                        }


                    }
                }
            }
            .product_add{
                text-align: center;
                line-height: 22px;
                span{
                    color: rgba(25, 144, 255, 1);
                    i{
                        font-size: 14px;
                        margin-right: 8px;
                    }
                }
            }
        }

        .field_item{
            width: 100%;
            border-top: 1px solid rgba(247, 248, 250, 1);
            padding: 10px 16px;
            box-sizing: border-box;

            .field_name{
                width: 100%;
                line-height: 22px;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 4px;
            }
            .field_content{
                width: 100%;
                .van-cell{
                    padding:0 0 4px 0;
                }
                ::v-deep .van-cell--required::before{
                    position: initial;
                    margin-right: 2px;
                }
                .file_list{
                    width: 100%;
                    ul{
                        width: 100%;
                        li{
                            width: 100%;
                            margin-bottom: 10px;
                            border-radius: 2px;
                            background: rgba(249, 249, 249, 1);
                            border: 1px solid rgba(217, 217, 217, 1);
                            line-height: 20px;
                            padding: 0 8px;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                width: calc(100% - 50px);
                                font-size: 12px;
                                color: rgba(102, 102, 102, 1);
                            }
                            div{
                                width: 48px;
                                span{
                                    width: 16px;
                                    margin-left: 8px;
                                    text-align: center;
                                    line-height: 16px;
                                }
                                i{
                                    font-size: 14px;
                                    color: rgba(102, 102, 102, 1);
                                }
                            }
                        }
                    }
                }
                .file_note{
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                    line-height: 18px;
                    margin-bottom: 34px;
                }
                .file_upload{
                    width: 100px;
                    position: relative;
                    line-height: 22px;
                    margin: 0 auto;
                    color: rgba(25, 144, 255, 1);
                    font-size: 14px;
                    text-align: center;
                    i{
                        margin-right: 8px;
                    }
                    input{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                }

            }
        }
    }
}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}

::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow{
    display: none !important;
}

.productItemBox{
    width: calc(100vw - 56px);
    padding: 8px 2px;
    box-sizing: border-box;
    max-height: 220px;
    overflow-y: auto;
    .product_item{
        width: 100%;
        line-height: 30px;
        padding: 0 12px;
        color: rgba(102, 102, 102, 1);
        &:active{
            color: rgba(102, 102, 102, 1);
            background: rgba(0, 0, 0, 0.04);
        }
        .product_name {
            display: block;
            width: calc(100% - 50px);
        }
        .product_tag {
            width: 40px;
            height: 22px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(240, 170, 50, 0.1);
            line-height: 22px;
            font-size: 12px;
            color: rgba(240, 170, 50, 1);
            text-align: center;
        }
    }

}
</style>
